// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.results .results-top {
  background-color: #f6f6f6;
  padding: 128px 0 30px 0;
}
.results .results-bottom {
  background-color: #f6f6f6;
  padding: 0 0 50px 0;
}
.results .results-bottom .table-end {
  text-align: center;
  border-radius: 8px;
  background-color: rgb(255, 255, 255);
  padding: 24px;
  overflow-x: scroll;
}
.results .results-bottom .table-end::-webkit-scrollbar {
  width: 20px;
  width: 20px;
}
.results .results-bottom .table-end h1 {
  font-family: "Roboto";
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  padding-bottom: 20px;
}
.results .results-bottom-table {
  display: flex;
}
.results .results-bottom table {
  width: 413px;
  border-collapse: collapse;
}
.results .results-bottom thead tr {
  border-bottom: 3px solid rgb(170, 170, 170);
}
.results .results-bottom thead tr th {
  color: rgb(153, 153, 153);
}
.results .results-bottom th,
.results .results-bottom td {
  padding: 10px; /* Add padding to cells */
  text-align: left; /* Align cell content to the left */
}
.results .results-center {
  background-color: #f6f6f6;
  padding-bottom: 32px;
  padding-top: 0;
}
.results .results-center__container {
  border-radius: 8px;
  background: #ffffff;
}
.results .results-center__title {
  color: #323232;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding: 24px;
}
.results .checkBilet {
  text-align: center;
  border-radius: 8px;
  background-color: rgb(255, 255, 255);
  padding: 24px;
}
.results .checkBilet h1 {
  font-family: "Roboto";
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  color: rgb(50, 50, 50) !important;
  padding-bottom: 16px;
}
.results .checkBilet form {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: center;
}
.results .checkBilet form button {
  padding: 10px 20px;
  border-radius: 8px;
  color: white;
  background-color: rgb(255, 0, 9);
}
.results .checkBilet form input {
  width: 280px;
  height: 39px;
  padding: 9px;
  border-radius: 8px;
  border: 1px solid rgb(153, 153, 153);
}
.results .checkBilet form input::placeholder {
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/modules/results/result.scss"],"names":[],"mappings":"AACE;EACE,yBAAA;EACA,uBAAA;AAAJ;AAEE;EACE,yBAAA;EACA,mBAAA;AAAJ;AACI;EACE,kBAAA;EACA,kBAAA;EACA,oCAAA;EACA,aAAA;EACA,kBAAA;AACN;AAMM;EACE,WAAA;EACA,WAAA;AAJR;AAMM;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;AAJR;AAOI;EACE,aAAA;AALN;AAOI;EACE,YAAA;EACA,yBAAA;AALN;AAQM;EACE,2CAAA;AANR;AAOQ;EACE,yBAAA;AALV;AAUI;;EAEE,aAAA,EAAA,yBAAA;EACA,gBAAA,EAAA,mCAAA;AARN;AAeE;EACE,yBAAA;EACA,oBAAA;EACA,cAAA;AAbJ;AAeI;EACE,kBAAA;EACA,mBAAA;AAbN;AAgBI;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;AAdN;AAiBE;EACE,kBAAA;EACA,kBAAA;EACA,oCAAA;EACA,aAAA;AAfJ;AAiBI;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iCAAA;EACA,oBAAA;AAfN;AAiBI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;AAfN;AAgBM;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,gCAAA;AAdR;AAgBM;EACE,YAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;AAdR;AAeQ;EACE,YAAA;AAbV","sourcesContent":[".results {\n  .results-top {\n    background-color: #f6f6f6;\n    padding: 128px 0 30px 0;\n  }\n  .results-bottom {\n    background-color: #f6f6f6;\n    padding: 0 0 50px 0;\n    .table-end {\n      text-align: center;\n      border-radius: 8px;\n      background-color: rgba(255, 255, 255, 1);\n      padding: 24px;\n      overflow-x: scroll;\n      // ::-webkit-scrollbar-track {\n      //   height: ;\n      // }\n      // ::-webkit-scrollbar-thumb {\n      //   background: #888;\n      // }\n      &::-webkit-scrollbar {\n        width: 20px;\n        width: 20px;\n      }\n      h1 {\n        font-family: 'Roboto';\n        font-size: 20px;\n        font-weight: 500;\n        line-height: 24px;\n        text-align: left;\n        padding-bottom: 20px;\n      }\n    }\n    &-table {\n      display: flex;\n    }\n    table {\n      width: 413px;\n      border-collapse: collapse;\n    }\n    thead {\n      tr {\n        border-bottom: 3px solid rgb(170, 170, 170);\n        th {\n          color: rgba(153, 153, 153, 1);\n        }\n      }\n    }\n\n    th,\n    td {\n      padding: 10px; /* Add padding to cells */\n      text-align: left; /* Align cell content to the left */\n    }\n\n    th {\n      // background-color: #f2f2f2; /* Add a light gray background to headers */\n    }\n  }\n  .results-center {\n    background-color: #f6f6f6;\n    padding-bottom: 32px;\n    padding-top: 0;\n\n    &__container {\n      border-radius: 8px;\n      background: #ffffff;\n    }\n\n    &__title {\n      color: #323232;\n      font-size: 20px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n      padding: 24px;\n    }\n  }\n  .checkBilet {\n    text-align: center;\n    border-radius: 8px;\n    background-color: rgba(255, 255, 255, 1);\n    padding: 24px;\n\n    h1 {\n      font-family: 'Roboto';\n      font-size: 20px;\n      font-weight: 500;\n      line-height: 24px;\n      color: rgba(50, 50, 50, 1) !important;\n      padding-bottom: 16px;\n    }\n    form {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      justify-content: center;\n      button {\n        padding: 10px 20px;\n        border-radius: 8px;\n        color: white;\n        background-color: rgba(255, 0, 9, 1);\n      }\n      input {\n        width: 280px;\n        height: 39px;\n        padding: 9px;\n        border-radius: 8px;\n        border: 1px solid rgba(153, 153, 153, 1);\n        &::placeholder {\n          opacity: 0.5;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
